module.exports = __webpack_public_path__ + "img/14.0584f97c.png";